module.exports = __webpack_public_path__ + "img/video_icon.c254ecaf.svg";